// Added by Sejune Oh on 2019-03-29
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { action, makeObservable, observable } from 'mobx'

import Rootstore from '../index'
import DataStorageStoreBase from '../base/DataStorageStoreBase'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface DSSeriesElementProps {
  id?: string
  fk_patient_id?: string
  fk_study_folder_id?: string
  fk_study_id?: string
  fk_series_folder_id?: string
  series_instance_uid?: string
  series_number?: number
  series_description?: string
  modality?: string
  body_part_examined?: string
  series_date_time?: string
  image_type?: string
  institution_name?: string
  manufacturer?: string
  station_name?: string
  manufacturer_model_name?: string
  software_versions?: string
  kvp?: number
  exposure_time?: number
  xray_tube_current?: number
  exposure?: number
  filter_type?: string
  convolution_kernel?: string
  repetition_time?: string
  echo_time?: string
  echo_train_length?: string
  trigger_time?: string
  sop_instance_count?: number
  workspace_path?: string
  tags?: Array<string>
  created_at?: string
  updated_at?: string
  deleted_at?: string
  fk_volume_disk_id?: string
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class DataStorageSeriesStore extends DataStorageStoreBase<DSSeriesElementProps> {
  totalCount: number = 0
  elements: Array<DSSeriesElementProps> = []
  root?: Rootstore

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(root: Rootstore) {
    super({ storeName: 'DS_StudyStore', apiSubUrl: 'dcm/series', _root: root })
    this.root = root
    makeObservable(this, {
      totalCount: observable,
      elements: observable,
      _setTotalCount: action,
      setElements: action,
    })
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getElement = async (id: string) => {
    return await super.get(id)
  }

  getElements = async (path: string) => {
    const rtnData = await super.getAll(path)
    await this._setTotalCount(parseInt(rtnData.total_count as string))
    return rtnData.items as Array<DSSeriesElementProps>
  }

  addElement = async (element: DSSeriesElementProps) => {
    const newElement = await super.add(element)
    return newElement.id
  }

  removeElement = async (id: string) => {
    return await super.remove(id)
  }

  updateElement = async (id: string, element: DSSeriesElementProps) => {
    const updatedElement = await super.update(id, element)
    return updatedElement.id
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  _setTotalCount = (count: number) => {
    this.totalCount = count
  }

  setElements = (elements: Array<DSSeriesElementProps>) => {
    this.elements = elements
  }
}
